(function () {
function slide(carousel, direction) {
  var track = carousel.querySelector('.cart-drawer__upsell-track');
  var cards = track.querySelectorAll('.cart-drawer__upsell-card');
  if (!cards.length) return;

  var cardWidth = track.clientWidth;
  var maxScroll = track.scrollWidth - track.clientWidth;
  var nextScroll = track.scrollLeft + direction * cardWidth;

  if (nextScroll < 5) {
    nextScroll = direction < 0 ? maxScroll : 0;
  } else if (nextScroll > maxScroll - 5) {
    nextScroll = direction > 0 ? 0 : maxScroll;
  }

  track.scrollTo({ left: nextScroll, behavior: 'smooth' });
}

  function refreshCartDrawer() {
    return fetch('/?section_id=cart-drawer')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('cart-drawer');
        var oldDrawer = document.querySelector('cart-drawer');
        if (newDrawer && oldDrawer) {
          var wasActive = oldDrawer.classList.contains('active');
          oldDrawer.replaceWith(newDrawer);
          if (wasActive) newDrawer.classList.add('active');
        }
      });
  }

  document.addEventListener('click', function (event) {
    var prevArrow = event.target.closest('.cart-drawer__upsell-arrow--prev');
    var nextArrow = event.target.closest('.cart-drawer__upsell-arrow--next');
    var addButton = event.target.closest('.cart-drawer__upsell-add');

    if (prevArrow) {
      slide(prevArrow.closest('.cart-drawer__upsell-carousel'), -1);
      return;
    }

    if (nextArrow) {
      slide(nextArrow.closest('.cart-drawer__upsell-carousel'), 1);
      return;
    }

    if (addButton) {
      var card = addButton.closest('.cart-drawer__upsell-card');
      var variantField = card.querySelector('.cart-drawer__upsell-variant');
      var variantId = variantField.value;
      var originalText = addButton.textContent;

      addButton.disabled = true;
      addButton.textContent = 'Añadiendo...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('No se pudo añadir el producto');
          return refreshCartDrawer();
        })
        .catch(function (error) {
          addButton.disabled = false;
          addButton.textContent = originalText;
          console.error(error);
        });
    }
  });
})();